import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContent } from '../../Common/Table/tableContent';
import services from '../services';
import { search, SearchFeild } from '../../Common';
import $ from 'jquery';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';
const screenCode = 'PRODUCT';

export function ProductListing(props){

    const [products, setProducts] = useState([]);
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false
    });
    
    const contentRowNames = ["productCode", "productName","productDescription", "isActive"]

    useEffect(() => {
    trackPromise(
        getPermissions()
        )
    }, []);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWPRODUCTLISTING');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITPRODUCT');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined
        });
        
        getAllProducts();
    }

    function destroyDataTable(){
        $('#example').DataTable().destroy();
    }

    function createDataTable(){
        $('#example').DataTable();
    }

    async function getAllProducts(){
        var data = await services.getAll()
        destroyDataTable()
        setProducts(data)
        createDataTable()
    }

    function handleClick(product) {
        props.history.push({
            pathname: 'products/addEdit',
            data: product,
            edit: true
        })
    }

    return (
        <Fragment>
        <LoadingSpinerComponent />
        <div className="row">
            <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Products"
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Add Products"
                            path="products/addEdit" />
                    <div className="card-body">
                      
                          
                       
                        <div className="table-responsive row-top-gap">
                            <table id="example" className="display dataTable no-footer">
                                <thead>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>Product Name</th>
                                        <th>Product Description</th>
                                        <th>Status</th>
                                        {permissionList.isAddEditEnabled ? <th>Actions</th> : null}
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContent
                                        data={products}
                                        hasEdit={permissionList.isAddEditEnabled}
                                        contentRowNames={contentRowNames}
                                        handleClick={handleClick} 
                                    />
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
    )
}


